import React from 'react';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import type ComponentTypesMetadata from '@atlassian/jira-compass-common/src/common/ui/component-types-metadata/index.tsx';
import { ComponentTypeIcon } from '@atlassian/jira-compass-common/src/ui/component-type-icons/index.tsx';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';

type Props = {
	componentId: string;
	name: string;
	description?: string;
	typeId: keyof typeof ComponentTypesMetadata;
};

export default function ComponentCell(props: Props) {
	const { componentId, name, description, typeId } = props;

	return (
		<Tooltip content={description ?? name}>
			{(tooltipProps) => (
				<Button
					{...tooltipProps}
					testId="project-directories.components.compass-table.cells.component.link"
					iconBefore={
						<Box xcss={iconWrapperStyles}>
							<ComponentTypeIcon type={typeId} />
						</Box>
					}
					appearance="link"
					spacing="none"
					href={`/compass/component/${componentId}`}
					target="_blank"
					onClick={(_, analyticsEvent) => {
						fireUIAnalytics(analyticsEvent, 'compassComponentLink');
					}}
				>
					{name}
				</Button>
			)}
		</Tooltip>
	);
}

const iconWrapperStyles = xcss({
	marginLeft: 'space.150',
	marginRight: 'space.150',
});
